import WizardTitleBlock from './WizardTitleBlock';

export default WizardTitleBlock;
